import request from "@/utils/request";

export function getOssToken(type: number) {
  return request({
    url: `/file/oss/getPublicBucketWriteStsTokenIn?directoryType=${type}`,
    method: "get",
  });
}
